'use client';

import { LeverageFinancialsValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorInputsProps {
  values: LeverageFinancialsValues;
  onValuesChange: (field: keyof LeverageFinancialsValues, value: number | string) => void;
  translations: ToolsTranslations['leverageFinancials'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: CalculatorInputsProps) {
  const handleInputChange = (field: keyof LeverageFinancialsValues, value: string) => {
    const numValue = parseFloat(value);
    if (!isNaN(numValue) && numValue >= 0) {
      onValuesChange(field, numValue);
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label htmlFor="product-price" className="block text-sm font-medium text-gray-700">
          {translations.productPrice}
        </label>
        <div className="relative">
          <input
            id="product-price"
            type="number"
            min="0"
            step="0.01"
            value={values.productPrice}
            onChange={(e) => handleInputChange('productPrice', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="0"
          />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
            {translations.currencySuffix}
          </span>
        </div>
      </div>

      <div className="space-y-3">
        <label htmlFor="financing-level" className="block text-sm font-medium text-gray-700">
          {translations.financingLevel}
        </label>
        <div className="relative">
          <input
            id="financing-level"
            type="number"
            min="0"
            step="0.01"
            value={values.financingLevel}
            onChange={(e) => handleInputChange('financingLevel', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="0"
          />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
            {translations.currencySuffix}
          </span>
        </div>
      </div>
    </div>
  );
}


